import { latestUpdates } from "@/mocks/doujinshi";

const ipNames: Record<string, string> = {
  naruto: "火影忍者",
  onepiece: "海贼王",
  jjk: "咒术回战",
  kimetsu: "鬼灭之刃",
  haikyu: "排球少年",
};

export default function LatestSection() {
  return (
    <section id="latest" className="w-full bg-background-950 py-16 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="inline-flex items-center gap-2 text-sm font-bold uppercase tracking-widest text-accent-400">
              <i className="ri-flashlight-fill"></i>
              FRESH
            </span>
            <h2 className="mt-3 font-heading text-2xl font-black text-foreground-950 md:text-4xl">
              最新更新
            </h2>
            <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-500 md:text-base">
              本周新增与连载跟进的同人作品，第一时间掌握你最爱的本命宇宙动态。
            </p>
          </div>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-10 lg:grid-cols-3">
          <div className="flex flex-col gap-4 lg:col-span-2">
            {latestUpdates.map((work) => (
              <article
                key={work.id}
                className="group flex gap-4 overflow-hidden rounded-lg bg-background-800/60 p-3 ring-1 ring-background-200/50 transition-all duration-300 hover:ring-accent-400/40 md:p-4"
              >
                <a href="#latest" className="relative block h-28 w-24 shrink-0 overflow-hidden rounded-md md:h-32 md:w-28">
                  <img
                    src={work.cover}
                    alt={`${work.title}同人漫画更新封面`}
                    title={`${work.title} 最新章节`}
                    className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                </a>
                <div className="flex flex-1 flex-col justify-between py-1">
                  <div>
                    <div className="flex flex-wrap items-center gap-2">
                      <span className="rounded-md bg-primary-500/20 px-2 py-0.5 text-xs font-bold text-primary-300">
                        {ipNames[work.ip]}
                      </span>
                      <span className="text-xs text-foreground-500">
                        {work.author} · {work.chapters}话
                      </span>
                    </div>
                    <h3 className="mt-2 font-heading text-base font-bold text-foreground-950 md:text-lg">
                      <a href="#latest" className="hover:text-accent-400">
                        {work.title}
                      </a>
                    </h3>
                    <p className="mt-1 line-clamp-2 text-sm leading-relaxed text-foreground-600">
                      {work.intro}
                    </p>
                  </div>
                  <div className="mt-3 flex flex-wrap items-center gap-2">
                    {work.tag.map((t) => (
                      <span
                        key={t}
                        className="rounded-full bg-secondary-500/15 px-2 py-0.5 text-xs text-secondary-300"
                      >
                        {t}
                      </span>
                    ))}
                    <span className="ml-auto inline-flex items-center gap-1 text-xs text-accent-400">
                      <i className="ri-time-line"></i>
                      {work.updated}
                    </span>
                  </div>
                </div>
              </article>
            ))}
          </div>

          <aside className="flex flex-col gap-6 rounded-lg bg-background-800/50 p-6 ring-1 ring-background-200/50">
            <div>
              <h3 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950">
                <i className="ri-trophy-line text-accent-400"></i>
                本周人气榜
              </h3>
              <ul className="mt-4 flex flex-col gap-1">
                {[
                  { rank: 1, name: "伟大航路的尽头", ip: "onepiece", views: "22.1万" },
                  { rank: 2, name: "木叶的黄昏", ip: "naruto", views: "18.6万" },
                  { rank: 3, name: "宿命之咒", ip: "jjk", views: "15.3万" },
                  { rank: 4, name: "月光下的剑舞", ip: "kimetsu", views: "12.8万" },
                  { rank: 5, name: "热血球场上的白鸟", ip: "haikyu", views: "9.6万" },
                ].map((item) => (
                  <li key={item.rank}>
                    <a
                      href="#featured"
                      className="flex items-center gap-3 rounded-md px-2 py-2.5 transition-colors hover:bg-background-700/40"
                    >
                      <span
                        className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-md text-sm font-black ${
                          item.rank <= 3
                            ? "bg-gradient-to-br from-accent-500 to-primary-500 text-background-50"
                            : "bg-background-700 text-foreground-400"
                        }`}
                      >
                        {item.rank}
                      </span>
                      <span className="min-w-0 flex-1">
                        <span className="block truncate text-sm font-medium text-foreground-900">
                          {item.name}
                        </span>
                        <span className="block text-xs text-foreground-500">{ipNames[item.ip]}</span>
                      </span>
                      <span className="text-xs text-foreground-500">{item.views}</span>
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div className="border-t border-background-200/50 pt-6">
              <h3 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950">
                <i className="ri-pen-nib-line text-accent-400"></i>
                入驻创作者
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                已有800+同人创作者入驻本站，持续产出高质量二创作品。欢迎加入，让你的创作被更多人看见。
              </p>
              <a
                href="#subscribe"
                className="mt-4 inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600"
              >
                <i className="ri-edit-2-line"></i>
                申请投稿
              </a>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}